<template>
    <div class="crew-remark-card">
        <textarea class="input-remark" v-model="localRemark[0]" @input="$emit('editing')" />
        <FormButtonList @save="onSave" @cancel="onCancel" />
    </div>
</template>
<script>
import FormButtonList from './FormButtonList.vue';
import EnterpriseManningVesselCrewService from '../../../services/master/EnterpriseManningVesselCrewService';
import { HandleHttpErrorService } from '../../../../utils/errors';

export default {
    components: { FormButtonList },
    props: {
        remarks: {
            type: Array,
            default: () => []
        },
        crewId: {
            type: [String, Number],
            required: true
        },
        version: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            localRemark: [...this.remarks]
        };
    },
    watch: {
        remarks(newVal) {
            this.localRemark = newVal;
        }
    },
    methods: {
        async onSave() {
            this.$vs.dialog({
                type: 'confirm',
                color: 'primary',
                title: '保存',
                text: '保存しますか？',
                cancelText: "キャンセル",
                acceptText: "OK",
                accept: async () => {
                    try {
                        await EnterpriseManningVesselCrewService.updateRemark(this.crewId, { remarks: this.localRemark[0], version: this.version });
                        this.$emit('saved');
                        this.$vs.notify({ title: '成功', text: '保存に成功しました', color: 'success' });
                    } catch (e) {
                        const errorMessage = HandleHttpErrorService.handleErrorNotificationMessage(e);
                        this.$vs.notify({ title: 'エラー', text: errorMessage || '更新に失敗しました。再読み込み後に再度お試しください。', color: 'danger' });
                        console.log(e);
                    }
                },
                cancel: () => {
                }
            });
        },
        onCancel() {
            this.$emit('cancel');
        }
    }
}
</script>
<style scoped>
.crew-remark-card {
    padding: 16px;
}

.input-remark {
    border: 1px solid #ccc;
    border-radius: 2px;
    width: 100%;
    height: 160px;
    padding: 13px 9px;
}
</style>
